module.exports = __webpack_public_path__ + "img/pie-chart-01.ac24645b.svg";